import { Component, Input, OnInit } from '@angular/core';
import { Position } from '../../../models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'rms-portfolio-optix-save-modal',
    templateUrl: './portfolio-optix-save-modal.component.html',
    styleUrls: ['./portfolio-optix-save-modal.component.scss'],
    standalone: false
})
export class PortfolioOptixSaveModalComponent implements OnInit {

  @Input() item: Position;
  @Input() newValues: {fv: number, dfv: number, pos: number};


  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
  }

  close() {
    this.activeModal.close();
  }

  save() {
    this.activeModal.close(true);
  }

}
